import { Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IAuthorizationService, PershingTranslationService } from '@pershing/pershing-core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CMSEvents, ContentManagementConstants, CustomHeader } from '../../static/ContentManagementConstants';

@Component({
    selector: 'content-management',
    templateUrl: './content-management.component.html',
    styleUrls: ['./content-management.component.css']
})

export class ContentManagementComponent implements OnInit, OnDestroy {
    @Input() communityName: string;
    @Input() articleId: string;
    @Input() isHeaderRequired: boolean = false;
    @Input() isFooter: boolean = false;
    @Input() entitlement: string;
    @Output() hasContent = new EventEmitter();
    isEntitledforView: boolean;
    content: any;
    public header: string = '';
    ibdCustSupportPhone: string;
    ibdName: string;
    documentsVersion: string;
    cdnHost: string;
    currentYear: string;
    isLoggedIn: boolean;
    isAda: boolean = false;
    showBackButton: boolean;
    themetype: string;
    cmsVersion: string;
    siteName: string;
    currentUrl: string;
    ibd: string;
    language: string;
    titleId: string;
    isLazyLoadOneTrustPage: boolean = false;
    isSiteBuilderSite: boolean = false;
    // configure contents supported by sitebuilder in an array somewhere in nxi-contentmanagement as a constant
    siteBuilderContent: any; // editableCmsList (list of contents supported by sitebuilder)
    isSitebuilderContent: boolean = false;
    showHeader: boolean = true; // flag to show/hide header title for cms components
    unsubscribe: Subject<void> = new Subject<void>();
    @ViewChild('contentDiv', { static: false }) contentDivRef: ElementRef;
    constructor(
        private translationService: PershingTranslationService,
        private translate: TranslateService,
        private authService: IAuthorizationService,
        @Optional() @Inject('AppSettings') appSettings: any, @Optional() private router: Router) {
        this.isLoggedIn = appSettings.isLoggedIn;
        if (this.router && this.router.url.indexOf('disclosure') > -1) {
            if (this.isLoggedIn) {
                this.showBackButton = true;
            }
        }
        this.translationService.addTranslationFolder('@pershing/nxi-contentmanagement', 'node_modules/@pershing/nxi-contentmanagement/lib');
        this.currentUrl = this.router ? this.router.url : '';
        this.cdnHost = appSettings.ibdConfigMap.cdnURL;
        this.currentYear = appSettings.currentYear;
        this.siteName = appSettings.cmsSiteName;
        this.language = this.translate.currentLang;
        this.ibd = appSettings.ibdConfigMap.IBD;
        this.isSiteBuilderSite = appSettings.isSitebuilder;
        if (appSettings.ibdConfigMap) {
            let parsemap = appSettings.ibdConfigMap;
            this.ibdCustSupportPhone = parsemap.ibdCustSupportPhone;
            this.ibdName = parsemap.ibdName;
            this.documentsVersion = parsemap.documents_version;
            this.communityName = parsemap.community;
            this.themetype = appSettings.themeType;
            if (parsemap.editableCmsList) {
                this.siteBuilderContent = parsemap.editableCmsList;
            }
            this.cmsVersion = parsemap.cms_version;
        }
        if (this.themetype === 'ada') {
            this.isAda = true;
        }
        if (appSettings.isLazyLoadOneTrustPage) {
            this.isLazyLoadOneTrustPage = true;
        }
    }

    ngOnInit(): void {
        if (this.entitlement !== undefined) {
            this.isEntitledforView = this.authService.isEntitled(this.entitlement);
        } else {
            this.isEntitledforView = true;
        }
        this.translationService.get(this.articleId).pipe(takeUntil(this.unsubscribe)).subscribe(data => { this.header = data; });
        if (this.communityName === undefined || this.isSiteBuilderSite) {
            console.log('communityName is undefined. defaulting to netxinvestor');
            this.communityName = 'netxinvestor';
        } else if (this.communityName.includes('ada-')) {
            this.communityName = this.communityName.split('-')[1];
        }
        if (this.articleId === undefined) {
            console.log('articleId is ' + this.articleId);
        }
        if (this.siteBuilderContent) {
            this.siteBuilderContent = this.siteBuilderContent.filter(editableCms => editableCms['cmsId'] === this.articleId)[0];
        }

        this.isSitebuilderContent = this.showCmsText();
        this.showHeader = this.showContentHeader();

        if (!this.isSitebuilderContent) {
            this.createScriptDynamically();
        }

        this.titleId = this.articleId;
        // customized header are replaced below.
        if (CustomHeader.propertyMap.get(this.ibd) && CustomHeader.propertyMap.get(this.ibd).get(this.articleId)) {
            this.titleId = CustomHeader.propertyMap.get(this.ibd).get(this.articleId);
        } else if (CustomHeader.propertyMap.get(this.communityName) && CustomHeader.propertyMap.get(this.communityName).get(this.articleId)) {
            this.titleId = CustomHeader.propertyMap.get(this.communityName).get(this.articleId);
        }
    }

    // check if is sitebuilder and whether the article id supplied to contentmanagement exists in editableCmsList
    showCmsText(): boolean {
        return !!this.siteBuilderContent && this.isSiteBuilderSite;
    }

    showContentHeader(): boolean {
        return this.isSitebuilderContent && this.siteBuilderContent['showHeader'];
    }
    createScriptDynamically() {
        let lang = "";
        let url = this.cdnHost;
        if (this.language == "es") {
            lang = "es";
        }
        let adaUrl = "/staticartifacts/@pershing/cms@" + this.cmsVersion + "/components/ibds/" + this.communityName + "/ada/" + lang + "/" + this.articleId + ".xml.js";
        let modernUrl = "/staticartifacts/@pershing/cms@" + this.cmsVersion + "/components/ibds/" + this.communityName + "/modern/" + lang + "/" + this.articleId + ".xml.js";
        let customUrl = "/staticartifacts/@pershing/cms@" + this.cmsVersion + "/components/ibds/" + this.communityName + "/custom/" + lang + "/" + this.articleId + ".xml.js";

        if (this.themetype == "ada") {
            url = url + adaUrl;
        } else if (this.themetype == "modern") {
            url = url + modernUrl;
        } else {
            url = url + customUrl;
        }
        let func = function (articleId, thisObj) {
            let abc: string = articleId;
            window[abc] = function (data) {
                if (data !== undefined && data !== null) {
                    data = data.substring(data.indexOf("<body>") + 6, data.indexOf("</body>"));
                    thisObj.fetchContentNxi(data);
                }
            }
        }(this.articleId, this);
        window[this.articleId]();
        let scriptElement = document.createElement("script");
        // Set the src and id attributes of the script element
        //scriptElement.src = "http://localhost:8080/site/components/ibds/investor/custom/"+this.articleId+".xml.js";
        scriptElement.src = url;
        scriptElement.type = 'text/javascript';
        
        // Get the head element
        let node = document.getElementsByTagName("head")[0];
        node.appendChild(scriptElement);
    }

    fetchContentNxi(data): void {
        if (data) {
            this.hasContent.emit({ articleId: this.articleId, hasContent: true });
            this.content = data
                .replace(new RegExp('"#"', 'g'), '"javascript:void(0);"')
                .replace(new RegExp('{ibdName}', 'g'), this.ibdName)
                .replace(new RegExp('{ibdCustSupportPhone}', 'g'), this.ibdCustSupportPhone)
                .replace(new RegExp('{currentYear}', 'g'), this.currentYear)
                .replace(new RegExp('{cdnHost}', 'g'), this.cdnHost)
                .replace(new RegExp('{documentsVersion}', 'g'), this.documentsVersion);
            if (!this.isLoggedIn) {
                ContentManagementConstants.postLoginUrls.forEach(element => {
                    this.content = this.content.replace(new RegExp(element, 'g'), '/nxi/login#');
                });
            }
            if (this.isLazyLoadOneTrustPage && this.articleId === 'cookie_notice') {
                const placeOneTrust = new CustomEvent(CMSEvents.PLACE_ONETRUST);
                document.dispatchEvent(placeOneTrust);
            }
            this.contentDivRef.nativeElement.innerHTML = this.content;
        } else {
            this.hasContent.emit({ articleId: this.articleId, hasContent: false });
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    backToPreviousRoute(): void {
        if (localStorage.getItem('previousUrl') === localStorage.getItem('lastUrlBeforeDisc')) {
            location.href = localStorage.getItem('previousUrl');
        } else {
            location.href = localStorage.getItem('lastUrlBeforeDisc');
        }
    }

    ngAfterViewChecked(): void {
        ContentManagementConstants.webContentsWithScript.forEach(element => {
            if (this.currentUrl.includes(element)) {
                document.dispatchEvent(new CustomEvent('currentRoute', {
                    detail: { 'currentRoute': element }
                }));
            }
        });
    }
}
